import {
  anAggregationRuleFunction,
  mockAggregationRuleFunctionsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockAggregationRuleFunctionsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          aggregationRuleFunctions: [
            anAggregationRuleFunction({
              name: 'avg',
            }),
            anAggregationRuleFunction({
              name: 'count',
            }),
            anAggregationRuleFunction({
              name: 'count_distinct',
            }),
            anAggregationRuleFunction({
              name: 'first',
            }),
            anAggregationRuleFunction({
              name: 'last',
            }),
            anAggregationRuleFunction({
              name: 'max',
            }),
            anAggregationRuleFunction({
              name: 'min',
            }),
            anAggregationRuleFunction({
              name: 'sum',
            }),
          ],
        },
      });
    }
  ),
];
